import {eq, every, flow, get, getOr, join, reduce, values} from 'lodash/fp';
import {createSelector} from 'reselect';

import {fromProps} from '/util/selector.util';

import {launchSequence as launchSequenceState} from './root.selector';

const uncappedReduce = reduce.convert({cap: false});

export const completedSteps = createSelector(
  launchSequenceState,
  get('completedSteps'),
);

export const stepsStatusString = createSelector(
  completedSteps,
  flow([
    uncappedReduce(
      (result: any, value: any, key: any) => [
        ...result,
        `${key}:${value ? 'Y' : 'N'}`,
      ],
      [],
    ),
    join('|'),
  ]),
);

export const completedAllSteps = createSelector(
  completedSteps,
  flow([values, every(eq(true))]),
);

export const completedStepByName = createSelector(
  fromProps(get('stepName')),
  completedSteps,
  (stepName, steps) => getOr(false, stepName)(steps),
);
